<template>
  <!-- Same mint confirmation tint as the detail pill when the reward is ready. -->
  <!-- The whole block opens an activated card, like the detail pill. -->
  <div
    class="flex items-center gap-3 rounded-2xl"
    :class="{
      'bg-secondary-lightest ring-1 ring-secondary p-2': analysis.state === 'done',
      'cursor-pointer': !!card.membership
    }"
    @click="card.membership && $emit('manage', card)"
  >
    <loyalty-card-ring
      :state="analysis.state"
      :percent="analysis.percent"
      :initials="analysis.initials"
      :logo="analysis.logoUrl"
      :gradient="analysis.gradient"
      :size="48"
    />
    <div class="flex-1 min-w-0 flex flex-col gap-1">
      <div class="flex items-baseline gap-2">
        <span class="text-base font-bold flex-1 min-w-0 truncate">{{ analysis.shortName }}</span>
        <span
          v-if="analysis.fillLabel"
          class="text-sm font-bold"
          :class="analysis.state === 'done' ? 'text-secondary-darkest' : 'text-primary'"
        >
          {{ analysis.fillLabel }}
        </span>
      </div>
      <div
        v-if="analysis.state !== 'inactive'"
        class="h-1.5 rounded-full bg-gray-light overflow-hidden"
      >
        <div
          class="h-full rounded-full"
          :class="analysis.state === 'done' ? 'bg-secondary-darkest' : 'bg-primary'"
          :style="{width: `${analysis.percent}%`}"
        />
      </div>
      <div class="flex flex-wrap items-center gap-x-2 gap-y-1.5">
        <span
          class="flex-1 min-w-[80px] text-sm"
          :class="analysis.state === 'done' ? 'text-secondary-darkest font-semibold' : 'text-gray-500'"
        >
          {{ analysis.hint }}
        </span>
        <button
          v-if="analysis.state === 'inactive'"
          class="shrink-0 bg-primary text-white text-sm font-semibold rounded-full px-3.5 py-1.5"
          @click.stop="$emit('activate', card)"
        >
          Activer
        </button>
        <!-- "Gérer" is always reachable; the reward button is a shortcut to
             the attribution, not a replacement for it. -->
        <div v-else class="ml-auto shrink-0 flex items-center gap-1">
          <button
            v-if="analysis.canOffer"
            class="shrink-0 flex items-center gap-1 text-primary-dark text-sm font-bold rounded-full px-3.5 py-1.5"
            :style="{background: `linear-gradient(135deg, ${colors.secondary.DEFAULT}, ${colors.green.DEFAULT})`}"
            @click.stop="$emit('reward', card)"
          >
            <Gift :size="12" />
            {{ analysis.rewardLabel }}
          </button>
          <button
            class="shrink-0 border border-primary text-primary text-sm font-semibold rounded-full px-3.5 py-1.5 bg-white"
            @click.stop="$emit('manage', card)"
          >
            Gérer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {Gift} from "@lucide/vue";
import {colors} from "@/theme/colors";
import {DetectionLoyaltyCard} from "@/notification/interfaces";
import LoyaltyCardRing from "@/notification/components/notification-detection/loyalty-cards/LoyaltyCardRing.vue";
import {DetectionCardAnalysis} from "@/notification/components/notification-detection/loyalty-cards/detectionCardAnalysis";

defineProps<{
    card: DetectionLoyaltyCard;
    /** Computed once by the parent and shared with the ring strip. */
    analysis: DetectionCardAnalysis;
}>();

defineEmits<{
    activate: [card: DetectionLoyaltyCard];
    manage: [card: DetectionLoyaltyCard];
    reward: [card: DetectionLoyaltyCard];
}>();
</script>
